import React from 'react';
import { FaBell, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useAdminData } from '../../context/AdminDataContext';

const Notifications = () => {
  const { notifications, clearNotifications, markAllNotificationsRead } = useAdminData();

  const formatTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleString();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <FaBell className="text-blue-600" />
          Admin Notifications
        </h1>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={markAllNotificationsRead}
            disabled={notifications.length === 0}
            className="px-3 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Mark all as read
          </button>
          <button
            type="button"
            onClick={clearNotifications}
            disabled={notifications.length === 0}
            className="px-3 py-2 text-sm rounded-lg bg-red-50 text-red-600 hover:bg-red-100 border border-red-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Clear
          </button>
        </div>
      </div>

      {notifications.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
          <FaBell className="mx-auto text-3xl mb-3 text-gray-400" />
          <p className="text-lg">No notifications yet</p>
          <p className="text-sm mt-1">Actions like adding products or charities will appear here.</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <ul className="divide-y divide-gray-200">
            {notifications.map((n) => (
              <li key={n.id} className="px-4 py-3 flex items-start gap-3 hover:bg-gray-50">
                <div className="mt-1">
                  {n.read ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : (
                    <FaBell className="text-blue-500" />
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center">
                    <p className="font-medium text-gray-900 text-sm">{n.title || 'Notification'}</p>
                    <span className="text-xs text-gray-500 ml-2">{formatTime(n.createdAt)}</span>
                  </div>
                  {n.message && (
                    <p className="text-sm text-gray-700 mt-1">{n.message}</p>
                  )}
                  {n.meta && (
                    <p className="text-xs text-gray-500 mt-1">{n.meta}</p>
                  )}
                  {n.type && (
                    <span className="inline-flex mt-2 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                      {n.type}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Notifications;
